import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/crm/quote-requests',
}).lazy(() => import('./quote-requests.index.lazy').then((d) => d.Route))
